import { useMemo, useRef, useState, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper';

//* Components
import Text from 'components/common/Text';
import Icon from 'components/common/Icon';
import Image from 'components/common/Image';

//* Style
import TipsStyle from './style';

const Tips = ({ className, slides, title }) => {
	//! State
	const [isArrowsVisible, setIsArrowsVisible] = useState(true);

	//! Refs
	const prevButton = useRef();
	const nextButton = useRef();

	useEffect(() => {
		if (prevButton.current?.[0].className.includes('swiper-button-disabled') && nextButton.current?.[0].className.includes('swiper-button-disabled')) {
			setIsArrowsVisible(false);
		}
	}, [prevButton.current, nextButton.current]);

	const storeTipSlides = useMemo(() => {
		return slides.map((slide, index) => {
			return (
				<SwiperSlide key={index}>
					<div className={`slide ${`bg` + slide.bgColor}`}>
						{slide.icon?.url && (
							<div className='icon-wrap'>
								<Image
									className={'tips-slide-icon'}
									objectFit={'contain'}
									src={slide.icon.url}
									alt={slide.icon.alt}
								/>
							</div>
						)}
						<Text
							className={'slide-text p pS font-ping-bold'}
							text={slide.description}
						/>
					</div>
				</SwiperSlide>
			);
		});
	}, [slides]);

	return (
		<TipsStyle className={className || ''}>
			<div className='title-and-arrows-wrap'>
				<Text
					tag={'h5'}
					className={'font-ping-bolder'}
					text={title}
				/>

				{isArrowsVisible && (
					<div className='arrows-wrap'>
						<Icon
							ref={prevButton}
							name={'arrow'}
							className='slider-button slider-tips-prev-button'
						/>
						<Icon
							ref={nextButton}
							name={'arrow'}
							className='slider-button slider-tips-next-button'
						/>
					</div>
				)}
			</div>
			<Swiper
				navigation={{
					prevEl: '.slider-tips-prev-button',
					nextEl: '.slider-tips-next-button',
				}}
				modules={[Navigation]}
				className='tips-slider'
				slidesPerView={4}
				draggable={true}
				breakpoints={{
					2560: {
						slidesPerView: 4,
					},
					1920: {
						slidesPerView: 4,
					},
					1510: {
						slidesPerView: 4,
					},
					1440: {
						slidesPerView: 4,
					},
					1280: {
						slidesPerView: 3,
					},
					1024: {
						slidesPerView: 3,
					},
					768: {
						slidesPerView: 2,
					},
					1: {
						slidesPerView: 1,
					},
				}}>
				{storeTipSlides}
			</Swiper>
		</TipsStyle>
	);
};

export default Tips;
